import { Fragment, ReactNode } from "react";

export default function TopBar({ crumbs, right }: { crumbs: ReactNode[]; right?: ReactNode }) {
  return (
    <div className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="dim"> / </span>}
            <span className={i < crumbs.length - 1 ? "dim" : ""}>{c}</span>
          </Fragment>
        ))}
      </div>
      <div style={{ flex: 1 }} />
      {right}
    </div>
  );
}
